<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <Header/>
        <b-card class="bCardAgenda">
            <b-container fluid="">
                <b-row class="divSubtitulo m-1 mb-3">
                <b-col cols="6" md="8">
                    <div>
                    <p class="textoSubtitulo">Plazos fijos</p>
                    </div>
                </b-col>
                <b-col cols="6" md="4">
                    <div>
                    <p style="text-align:end" class="textoSubtitulo">CODIGO</p>
                    </div>
                </b-col>
                </b-row>
            </b-container>

            <div class="mt-2 col-md-12"></div>

            <b-container fluid="">
                <b-row class="text-center mt-4">
                    <b-col cols="1" md="3">
                    </b-col>
                    <b-col cols="9" md="6" >
                        <b-row class="contenedorTablaSinColor" style="background:white ">
                            <b-col cols="10" lg="11" class="pr-0">
                                <b-input-group class="pl-3" v-if="$localStorageService.can('Plazofijo_buscar')">
                                    <b-form-input
                                    class="input-filter"
                                    v-model="filtro.numeroPlazo"
                                    type="search"
                                    id="filterInput"
                                    responsive
                                    placeholder="Búsqueda de plazos fijos"
                                    @keydown.enter.native="buscarPlazoFijo()"
                                    >
                                    </b-form-input>
                                </b-input-group>
                            </b-col>
                            <b-col cols="2" lg="1" class="pl-0">
                                <b-button
                                    class="mt-1 pb-1"
                                    size="sm"
                                    variant="info"
                                    :disabled="loader"
                                    @click="buscarPlazoFijo"
                                    responsive
                                >
                                <span v-if="!loader"
                                >
                                    <em class="buscar_svg primary sm"></em>
                                </span>
                                <span v-else><b-spinner small></b-spinner></span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col cols="1" class="text-left mt-auto mb-auto">
                        <b-button
                            variant="ligth"
                            v-b-tooltip.hover.lefttop.v-light
                            class="paddingbotones "
                            size="sm"
                            pill
                            v-b-tooltip.hover
                            title="Alta de plazo fijo"
                            @click="agregar()"
                            responsive
                        ><em class="btn_plus_circle" style="width: 24px;"></em>
                        </b-button>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12" md="12" lg="12" class="contenedorTablaSinColor mt-5">
                        <b-table
                            :hover="true"
                            :small="true"
                            style="font-size: 12px !important; padding: 0.1rem;"
                            responsive
                            fixed
                            thead-tr-class="columnasTablaSinColorLetter"
                            :items="datosTabla"
                            :fields="fields"
                            :per-page="$registrosPorPaginaTabla"
                            :current-page="paginaActual">
                            <template v-slot:cell(Acciones)="row">
                                <b-button-group>
                                    <b-button 
                                            title="Modificar Plazo fijo"
                                            size="sm"
                                            @click="modificar(row.item)"
                                            variant="outline-warning"
                                    ><em class="fa fa-pencil"></em></b-button>
                                    <b-button v-if="!row.item.registroActivo"
                                            title="Activar Plazo fijo"
                                            variant="outline-danger"
                                            size="sm"
                                            @click="activar(row.item)"
                                    ><em class="fa fa-undo"></em></b-button>
                                    <b-button v-if="$localStorageService.can('Plazofijo_inactivar') && row.item.registroActivo"
                                            title="Desactivar Plazo fijo"
                                            variant="outline-danger"
                                            size="sm"
                                            @click="desactivar(row.item)"
                                    >
                                        <b-icon icon="trash-fill"></b-icon>
                                    </b-button>
                                </b-button-group>

                            </template>
                        </b-table>
                        <div align="center" v-if="loader">
                            <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </div>
                        <b-col v-if="!loader">
                            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
                        </b-col>
                        <b-col v-if="!loader">
                            <b-pagination
                                    v-if="datosTabla !== undefined && datosTabla.length > 10"
                                    align="center"
                                    v-model="paginaActual"
                                    :total-rows="datosTabla.length"
                                    :per-page="$registrosPorPaginaTabla"
                                    aria-controls="my-table1"
                            ></b-pagination>
                        </b-col>
                    </b-col>
                </b-row>
            </b-container>
        </b-card>
  
  
        <b-modal
          v-model="show"
          :title="tituloModal"
          size="md"
          scrollable
          hide-footer
        >
            <b-form @submit.stop.prevent="guardar">
            <b-container fluid>
                <b-row>
                    <b-col cols="6">
                        <b-form-group align="left">
                            <label for="clave">Número de plazos
                                <validacion />
                            </label>
                            <b-input-group size="sm" class="mb-2" id="clave">
                                <b-form-input
                                    class="redondeo"
                                    id="idNumeroPlazos"
                                    placeholder="Ingresa el número de plazos"
                                    :state="validateState('numeroPlazo')"
                                    v-model="$v.plazoFijo.numeroPlazo.$model"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-container>
                <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
            </b-form>

            <div class="text-center">
              <b-button
                  class="mt-3 botonesAzulFuerte"
                  variant="primary"
                  style="margin:10px"
                  @click="submitGuardar">Guardar</b-button>

              <b-button
                  class="mt-3 botonesGrisFuerte"
                  style="margin:10px"
                  @click="cerrarModal()">Cancelar
              </b-button>
            </div>
        </b-modal>
    </div>
</template>
  
<script>
import Header from "../../components/Header";
    import {validationMixin} from "vuelidate";
    import {required} from "vuelidate/lib/validators";
  
    export default {
        name: "PlazoFijo",
        components: {
            Header
        },
        mixins: [validationMixin],
        data: () =>{
            return {
              version: process.env.VUE_APP_ENV_VERSION,
              debug: false,
                datosTabla: [],
                fields: [
                {key: "idPlazoFijo", label: "ID", sortable: true},
                {key: "numeroPlazo", label: "Numero de plazo", sortable: true},
                "Acciones",
                ],
                paginaActual: 1,
                show: false,
                tituloModal: '',
                plazoFijo: {
                    idPlazoFijo: null,
                    numeroPlazo: null
                },
                filtro: {
                    id: null,
                    numeroPlazo: null,
                    registroActivo: null
                },
                loaderAcciones: false,
                loader: false,
            }
        },
        validations: {
            plazoFijo: {
                numeroPlazo: {required},
            }
        },
        created() {
          this.debug = this.$localStorageService.getDebug();
            this.obtener();
        },
        methods: {
            buscarPlazoFijo() {
                this.paginaActual = 1;
                this.loader = true;
                this.datosTabla = [];
                this.$http.post(this.$api + "plazoFijo/obtener",this.filtro).then((response) => {
                    this.datosTabla = response.data.data;
                }).finally(() => {
                    this.loader = false;
                });
            },
            obtener(){
                this.loader = true;
                this.datosTabla = [];
                this.$http.post(this.$api + "plazoFijo/obtener", this.filtro).then(respuesta => {
                    if (respuesta.data.data) {
                        respuesta.data.data.forEach(it => {
                            this.paginaActual=1;
                            this.datosTabla.push(it)
                        })
                    }
                }
                ).finally(() => {
                    this.loader = false;
                })
            },
            agregar() {
                this.$nextTick(() => {
                    this.$v.$reset()
                });
                this.plazoFijo = {
                    idPlazoFijo: null,
                    numeroPlazo: null
                };
                this.tituloModal = 'Agregar Plazo fijo';
                this.show = true;
            },
            modificar(item) {
                this.$nextTick(() => {
                    this.$v.$reset()
                });
                this.plazoFijo = JSON.parse(JSON.stringify(item));
                this.tituloModal = 'Modificar Plazo fijo';
                this.show = true;
            },
            submitGuardar() {
                this.$refs.submitGuardar.click();
            },
            guardar() {
                this.$v.plazoFijo.$touch();
                if (this.$v.plazoFijo.$anyError){
                    return;
                }
                if (!this.$v.plazoFijo.$invalid) {
                    this.loaderAcciones = true;
                    this.$http.post(this.$api + "plazoFijo/guardar", this.plazoFijo).then(respuesta => {
                        console.log("respuesta.data.data",respuesta.data.data)
                        if (respuesta.data.data) {
                            this.$swal.fire({
                                icon: "info",
                                title: "Aviso",
                                text: "El Plazo Fijo se registro correctamente",
                            });
                            this.filtro.numeroPlazo = this.plazoFijo.numeroPlazo;
                            this.obtener();
                            this.show = false;
                        }
                    }
                    ).catch(error => {
                        console.error(error);
                        this.$swal.fire({
                            icon: "error",
                            title: "Aviso",
                            text: "El Plazo Fijo ya existe",
                        });
                    }).finally(() => {
                        this.loaderAcciones = false;
                    }
                    )
                }
            },
            activar(item) {
                this.$swal({
                    icon: "error",
                    text: "¿Está seguro de activar el plazo fijo?",
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                    showConfirmButton: true,
                }).then((aceptar) => {
                    if(aceptar.value){
                        this.$http.post(this.$api + "plazoFijo/activarDesactivar", item.idPlazoFijo).then((response) => {
                            if (response.data.data) {
                            this.buscarPlazoFijo();
                                this.$swal.fire({
                                    position: "center",
                                    icon: "info",
                                    title: "Aviso",
                                    text:"Se activó el plazo fijo ",
                                    showConfirmButton: false,
                                    timer: 3500,
                                });
                            }
                        });
                    }
                })
            },
            desactivar(item){
                this.$swal({
                    icon: "warning",
                    text: "¿Está seguro de desactivar el plazo fijo?",
                    confirmButtonText: 'Si',
                    cancelButtonText: 'No',
                    showCancelButton: true,
                    showConfirmButton: true,
                }).then((aceptar) => {
                    if(aceptar.value){
                        this.$http.post(this.$api + "plazoFijo/activarDesactivar", item.idPlazoFijo).then((response) => {
                            if (response.data.data) {
                            this.buscarPlazoFijo();
                                this.$swal.fire({
                                    position: "center",
                                    icon: "info",
                                    title: "Aviso",
                                    text:"Se desactivó el plazo fijo ",
                                    showConfirmButton: false,
                                    timer: 3500,
                                });
                            }
                        });
                    }
                })
            },
            validateState(name){
                const {$dirty, $error} = this.$v.plazoFijo[name];
                return $dirty ? !$error : null;
            },
            cerrarModal(){
                this.show = false;
            }
        }
    }
</script>
<style scoped>
    .paddingbotones {
        padding: 5px;
    }

    .botonesAzulFuerte {
        border-radius: 10rem;
        color: #fff;
        background-color: var(--color-icono);
        border-color: var(--color-icono);
        margin-left: 5%;
    }
</style>